// ./src/utils/holidayUtils.js

import { isHoliday } from 'holidays-cn';

// 从全局配置中读取工作时间
const handhoilday = window.curProInfo.handhoilday;
const handhoildayValue = window.curProInfo.handhoildayValue;

/**
 * 解析时间字符串（格式："HH:MM"）为总分钟数
 * @param {string} timeStr - 时间字符串，格式为 "HH:MM"
 * @returns {number} - 总分钟数，若格式错误返回 NaN
 */
const parseTimeToMinutes = (timeStr) => {
    if (typeof timeStr !== 'string') {
        console.error(`时间格式错误：${timeStr} 不是字符串`);
        return NaN;
    }

    const [hours, minutes] = timeStr.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
        console.error(`时间格式错误：${timeStr}`);
        return NaN;
    }
    return hours * 60 + minutes;
};

/**
 * 判断给定日期是否为工作日，并且时间在配置的工作时间范围内
 * @param {Date|number|string} [inputDate=new Date()] - 要检查的日期，可以是 Date 对象、时间戳（number 或字符串）
 * @returns {boolean} - 如果是工作日且时间在指定范围内，返回 true，否则返回 false
 */
export const isWorkingTime = (inputDate = new Date()) => {
    // 如果不开启工作日限制，直接返回 true
    if (!handhoilday) {
        return true;
    }

    // 如果缺少工作时间配置，返回 true
    if (!handhoildayValue || !handhoildayValue.startTime || !handhoildayValue.endTime) {
        console.warn("未正确配置工作时间（handhoildayValue.startTime 或 handhoildayValue.endTime），默认返回 true");
        return true;
    }

    let date;
    // inputDate = 1736294682000;//这个是假期的时间戳
    // 处理输入类型
    if (typeof inputDate === 'number' || typeof inputDate === 'string') {
        const timestamp = typeof inputDate === 'string' ? parseInt(inputDate, 10) : inputDate;
        if (isNaN(timestamp)) {
            console.error(`无效的时间戳：${inputDate}`);
            return true;
        }
        date = new Date(timestamp);
    } else if (inputDate instanceof Date) {
        date = inputDate;
    } else {
        console.error('输入必须是一个 Date 对象、时间戳（number 或字符串）');
        return true;
    }

    if (!(date instanceof Date) || isNaN(date)) {
        console.error('输入的日期无效');
        return true;
    }

    // 获取日期部分并格式化为 'YYYY-MM-DD'
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 月份从0开始
    const day = date.getDate();
    const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    // 判断是否为法定节假日
    if (isHoliday(formattedDate)) {
        return false;
    }

    // 判断是否为周末
    const dayOfWeek = date.getDay(); // 0: 周日, 6: 周六
    if (dayOfWeek === 0 || dayOfWeek === 6) {
        return false;
    }

    // 获取时间部分
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // 转换时间为分钟数，方便比较
    const totalMinutes = hours * 60 + minutes;
    const startMinutes = parseTimeToMinutes(handhoildayValue.startTime); // 配置的开始时间
    const endMinutes = parseTimeToMinutes(handhoildayValue.endTime);     // 配置的结束时间

    if (isNaN(startMinutes) || isNaN(endMinutes)) {
        console.warn("工作时间配置存在问题，无法进行时间判断，默认返回 true");
        return true;
    }

    // 判断时间是否在配置的工作时间范围内
    if (totalMinutes >= startMinutes && totalMinutes <= endMinutes) {
        return true;
    }

    return false;
};
